import type { SecuritySchemaDataSource } from 'components/SecuritySchema/model/SecuritySchemaDataSource';
import type { SecuritySchemaEntryPoint } from 'components/SecuritySchema/model/SecuritySchemaEntryPoint';
import {
  type SecuritySchemaModel,
  initialSecuritySchemaState,
} from 'components/SecuritySchema/model/SecuritySchemaModel';
import { loadDeviceSecurity } from 'components/SecuritySchema/model/commands/loadDeviceSecurity';
import { useEffect, useMemo, useRef } from 'react';
import { useCommandModel } from 'utils/hooks/useCommandModel';
import { useApi } from 'utils/request/useApi';

type Props = {
  entryPoint: SecuritySchemaEntryPoint;
  dataSource: SecuritySchemaDataSource;
  highlightedRuleLabel?: string;
};

export const useSecuritySchema = (props: Props): SecuritySchemaModel => {
  const treeScrollContainerRef = useRef(null);
  const model = useCommandModel(
    initialSecuritySchemaState,
    {
      apiRequest: useApi().request,
    },
    {
      highlightedRuleLabel: props.highlightedRuleLabel,
    },
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies(props.entryPoint): Not guaranteed to be stable but should not trigger load
  useEffect(() => {
    model.dispatch(loadDeviceSecurity, {
      dataSource: props.dataSource,
      entryPoint: props.entryPoint,
    });
  }, [props.dataSource, model.dispatch]);

  return useMemo(
    () => ({
      ...model,
      treeScrollContainerRef,
    }),
    [model],
  );
};
